"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertArrayToObject = exports.isArrayOfStrings = exports.isString = exports.getEnumValues = exports.undefinedObj = exports.getEnumKeyOrUndefined = exports.getEnumKey = exports.getObjectCompareDifferenceFields = exports.objectCompare = exports.removeEmptyObjects = exports.randomString = exports.anyDiffs = exports.concatFirstElement = exports.applyUpdates = exports.isAllFieldsEmpty = exports.removeUndefined = exports.removeEmpty = exports.equalsOrIncludesPredicate = exports.isObjectDefined = exports.notEmpty = exports.mapAllNotNullFieldsWithPrefix = exports.mapAllNotNullFields = exports.deepCopyNotNullFields = exports.mapNotNullFields = exports.toObject = exports.toKeyIfEqualsIgnoreCase = exports.equalsIgnoreCase = exports.isSameId = exports.getId = exports.notTrue = exports.isFalse = exports.isTrue = exports.notNull = void 0;
const notNull = (value) => value != null;
exports.notNull = notNull;
const isTrue = (value) => value === true;
exports.isTrue = isTrue;
const isFalse = (value) => value === false;
exports.isFalse = isFalse;
const notTrue = (value) => value !== true;
exports.notTrue = notTrue;
const getId = (obj) => (obj ? obj.id : null);
exports.getId = getId;
const isSameId = (id) => (obj) => exports.getId(obj) === id;
exports.isSameId = isSameId;
function equalsIgnoreCase(a, b) {
    if (a && b) {
        return a.toUpperCase() === b.toUpperCase();
    }
    return !a && !b;
}
exports.equalsIgnoreCase = equalsIgnoreCase;
function toKeyIfEqualsIgnoreCase(key, value, oldKey) {
    const matchKey = oldKey !== null && oldKey !== void 0 ? oldKey : key;
    if (value != null && matchKey.toUpperCase() === value.toUpperCase()) {
        return key;
    }
    return undefined;
}
exports.toKeyIfEqualsIgnoreCase = toKeyIfEqualsIgnoreCase;
const toObject = (pairs) => Array.from(pairs).reduce((acc, [key, value]) => Object.assign(acc, { [key]: value }), {});
exports.toObject = toObject;
function mapNotNullFields(data = {}, fields) {
    const obj = {};
    if (fields) {
        const mapFields = Array.isArray(fields)
            ? undefined
            : fields;
        const inputFields = Array.isArray(fields)
            ? fields
            : Object.keys(fields);
        if (data && data instanceof Object)
            inputFields.forEach((field) => {
                if (data[field]) {
                    const newField = mapFields ? mapFields[field] : field;
                    obj[newField] = data[field];
                }
            });
    }
    return obj;
}
exports.mapNotNullFields = mapNotNullFields;
function deepCopyNotNullFields(data = {}, fields) {
    const obj = {};
    if (data) {
        if (data instanceof Object) {
            const inputFields = fields || Object.keys(data);
            inputFields.forEach((field) => {
                let value = data[field];
                if (value !== undefined && exports.notNull(value)) {
                    if (value instanceof Object) {
                        value = deepCopyNotNullFields(value);
                    }
                    obj[field] = value;
                }
            });
        }
    }
    return obj;
}
exports.deepCopyNotNullFields = deepCopyNotNullFields;
function mapAllNotNullFields(data, remapFields = {}) {
    const fields = Object.assign({}, remapFields);
    const mapToFields = Object.values(fields);
    Object.keys(data)
        .filter((field) => !fields[field] && !mapToFields.includes(field))
        .forEach((field) => {
        fields[field] = field;
    });
    return mapNotNullFields(data, fields);
}
exports.mapAllNotNullFields = mapAllNotNullFields;
function mapAllNotNullFieldsWithPrefix(data, prefix) {
    const fields = {};
    Object.keys(data).forEach((field) => {
        const toField = prefix + field.substring(0, 1).toUpperCase() + field.substring(1);
        fields[field] = toField;
    });
    return mapNotNullFields(data, fields);
}
exports.mapAllNotNullFieldsWithPrefix = mapAllNotNullFieldsWithPrefix;
const notEmpty = (v) => v != null && v !== "";
exports.notEmpty = notEmpty;
const isObjectDefined = (obj) => !!obj;
exports.isObjectDefined = isObjectDefined;
const equalsOrIncludesPredicate = (value) => (matchValue) => {
    if (Array.isArray(value)) {
        return value.includes(matchValue);
    }
    return value === matchValue;
};
exports.equalsOrIncludesPredicate = equalsOrIncludesPredicate;
function filterFn(v) {
    return v != null && typeof v !== "function";
}
function passThroughFn(passThroughTypes, v) {
    return passThroughTypes.some((type) => v instanceof type);
}
const removeEmpty = (obj, passThroughTypes = []) => {
    if (Array.isArray(obj)) {
        return obj.filter(filterFn).map((v) => exports.removeEmpty(v, passThroughTypes));
    }
    if (typeof obj === "object") {
        if (passThroughFn(passThroughTypes, obj)) {
            return obj;
        }
        const cleanedObj = {};
        Object.entries(obj)
            .filter(([, v]) => filterFn(v))
            .map(([k, v]) => [k, exports.removeEmpty(v, passThroughTypes)])
            .forEach(([k, v]) => (cleanedObj[k] = v));
        return cleanedObj;
    }
    if (obj != null) {
        return obj;
    }
    return undefined;
};
exports.removeEmpty = removeEmpty;
const removeUndefined = (obj) => {
    if (Array.isArray(obj)) {
        return obj.map((v) => exports.removeUndefined(v));
    }
    if (typeof obj === "object") {
        return Object.fromEntries(Object.entries(obj)
            .filter(([_, v]) => v !== undefined)
            .map(([k, v]) => [k, v === Object(v) ? exports.removeUndefined(v) : v]));
    }
    return obj !== undefined ? obj : null;
};
exports.removeUndefined = removeUndefined;
function isAllFieldsEmpty(data, fields = []) {
    return fields.map((field) => data[field]).every((value) => value === null);
}
exports.isAllFieldsEmpty = isAllFieldsEmpty;
const applyUpdates = (doc, updates) => {
    let updated = false;
    Object.keys(updates).forEach((key) => {
        if (doc[key] !== updates[key]) {
            doc[key] = updates[key];
            updated = true;
        }
    });
    return updated;
};
exports.applyUpdates = applyUpdates;
const concatFirstElement = (...lists) => lists.filter((list) => list.length > 0).map((list) => list[0]);
exports.concatFirstElement = concatFirstElement;
const anyDiffs = (objA, objB, fields = []) => fields.some((field) => objA[field] !== objB[field]);
exports.anyDiffs = anyDiffs;
function randomString(len, an = "alphanumeric") {
    let str = "";
    const min = an === "alphanumeric" ? 10 : 0;
    const max = an === "numeric" ? 10 : 62;
    for (let i = 0; i++ < len;) {
        let r = (Math.random() * (max - min) + min) << 0;
        str += String.fromCharCode((r += r > 9 ? (r < 36 ? 55 : 61) : 48));
    }
    return str;
}
exports.randomString = randomString;
function removeEmptyObjects(obj) {
    Object.keys(obj).forEach((key) => {
        const subObj = obj[key];
        if (subObj instanceof Object) {
            removeEmptyObjects(subObj);
            if (!Object.keys(subObj).length) {
                delete obj[key];
            }
        }
    });
}
exports.removeEmptyObjects = removeEmptyObjects;
const objectCompare = (objectA, objectB = {}, ignoreFields, includeFields) => {
    let diffObj = {};
    switch (true) {
        case Array.isArray(objectA):
            if (typeof objectA[0] === "object" || Array.isArray(objectA[0])) {
                objectA.forEach((elem, index) => {
                    if (!Array.isArray(diffObj))
                        diffObj = [];
                    diffObj[index] = exports.objectCompare(elem, (objectB || [])[index]);
                });
            }
            else if (typeof objectA[0] === "string" ||
                typeof objectA[0] === "number") {
                if (Array.isArray(objectB)) {
                    diffObj = objectA
                        .filter((x) => !objectB.includes(x))
                        .concat(objectB.filter((x) => !objectA.includes(x)));
                }
                else {
                    diffObj = objectB;
                }
            }
            break;
        case objectA !== null && typeof objectA === "object":
            Object.keys(objectA).forEach((key) => {
                if (Array.isArray(objectA[key])) {
                    let arr = exports.objectCompare(objectA[key], objectB[key]);
                    if (!Array.isArray(arr))
                        arr = [];
                    arr.forEach((elem, index) => {
                        if (!Array.isArray(diffObj[key]))
                            diffObj[key] = [];
                        diffObj[key][index] = elem;
                    });
                }
                else if (typeof objectA[key] === "object") {
                    diffObj[key] = exports.objectCompare(objectA[key], objectB[key]);
                }
                else if (objectA[key] !== (objectB || {})[key]) {
                    if (objectA[key] === undefined && typeof objectB[key] === "object") {
                        diffObj[key] = objectB[key];
                    }
                    else {
                        diffObj[key] = objectA[key];
                    }
                }
            });
            break;
        default:
            break;
    }
    Object.keys(diffObj).forEach((key) => {
        if (typeof diffObj[key] === "object" &&
            JSON.stringify(diffObj[key]) === "{}")
            delete diffObj[key];
    });
    ignoreFields === null || ignoreFields === void 0 ? void 0 : ignoreFields.forEach((fullPath) => {
        const parts = fullPath.split(".");
        const pathParts = parts.slice(0, -1);
        const field = parts[parts.length - 1];
        const data = pathParts.reduce((obj, pathPart) => (obj ? obj[pathPart] : undefined), diffObj);
        if (data) {
            delete data[field];
        }
    });
    removeEmptyObjects(diffObj);
    if (includeFields && Object.keys(includeFields).length) {
        const newDiffObj = {};
        includeFields.forEach((fullPath) => {
            const parts = fullPath.split(".");
            const data = parts.reduce((obj, pathPart) => (obj ? obj[pathPart] : undefined), diffObj);
            const pathParts = parts.slice(0, -1);
            const field = parts[parts.length - 1];
            if (data) {
                const ref = pathParts.reduce((obj, pathPart) => {
                    if (!obj[pathPart]) {
                        obj[pathPart] = {};
                    }
                    return obj[pathPart];
                }, newDiffObj);
                ref[field] = data;
            }
        });
        return newDiffObj;
    }
    return diffObj;
};
exports.objectCompare = objectCompare;
const getObjectCompareDifferenceFields = (diffObj, prefix) => Object.entries(diffObj).flatMap(([key, entry]) => {
    if (typeof entry === "object") {
        return exports.getObjectCompareDifferenceFields(entry, key);
    }
    return prefix ? `${prefix}.${key}` : key;
});
exports.getObjectCompareDifferenceFields = getObjectCompareDifferenceFields;
function getEnumKey(name, enumObject, key) {
    if (key) {
        const found = Object.entries(enumObject).find(([, enumValue]) => enumValue === key);
        if (found) {
            return enumObject[found[0]];
        }
    }
    throw new Error(`${name} invalid value: ${key}`);
}
exports.getEnumKey = getEnumKey;
function getEnumKeyOrUndefined(name, enumObject, key) {
    try {
        return getEnumKey(name, enumObject, key);
    }
    catch (error) {
    }
    return undefined;
}
exports.getEnumKeyOrUndefined = getEnumKeyOrUndefined;
function undefinedObj(keys) {
    const obj = {};
    keys.forEach((key) => {
        obj[key] = undefined;
    });
    return obj;
}
exports.undefinedObj = undefinedObj;
const getEnumValues = (e) => typeof e === "object" ? Object.keys(e).map((key) => e[key]) : [];
exports.getEnumValues = getEnumValues;
const isString = (element) => typeof element === "string";
exports.isString = isString;
const isArrayOfStrings = (array) => array.every((element) => exports.isString(element));
exports.isArrayOfStrings = isArrayOfStrings;
const convertArrayToObject = (array) => {
    const resultFormat = {};
    array.forEach((item) => {
        if (item) {
            const key = Object.keys(item)[0];
            resultFormat[key] = item[key];
        }
    });
    return resultFormat;
};
exports.convertArrayToObject = convertArrayToObject;
//# sourceMappingURL=index.js.map